(function () {
  'use strict';

  angular
    .module('iqxCore')
    .config($ocLazyLoadProviderConfig)

  function $ocLazyLoadProviderConfig($ocLazyLoadProvider) {
    $ocLazyLoadProvider.config({
      modules: [
        {
          name: 'iqxD3',
          files: [
            '/assets/lib/d3/d3.min.js',
            '/assets/lib/d3/nv.d3.min.js',
            '/assets/lib/d3/nv.d3.min.css'
          ],
          serie: true
        },
        {
          name: 'iqxChart',
          files: [
            '/assets/lib/chart.js/Chart.min.js'
          ],
          serie: false
        },
        {
          name: 'iqxCalendar',
          files: [
            '/assets/lib/angular-bootstrap-calendar/angular-bootstrap-calendar-tpls.min.js',
            '/assets/lib/angular-bootstrap-calendar/angular-bootstrap-calendar.min.css'
          ],
          serie: false
        },
        {
          name: 'iqxPdf',
          files: [
            '/assets/lib/pdfmake/pdfmake.min.js',
            '/assets/lib/pdfmake/vfs_fonts.js',
            '/assets/lib/html2canvas/html2canvas.js'
          ],
          serie: true
        },
        {
          name: 'iqxTree',
          files: [
            '/assets/lib/angular-ui-tree/angular-ui-tree.min.js',
            '/assets/lib/angular-ui-tree/angular-ui-tree.min.css'
          ],
          serie: false
        },
        {
          name: 'iqxAppLanding',
          files: [
            '/assets/applanding.js'
          ],
          serie: false
        },
        {
          name: 'iqxVideo',
          files: [
            '/assets/lib/recordrtc/RecordRTC.js',
          ],
          serie: true
        },
      ]
    })
  }

})()